module.exports = __webpack_public_path__ + "media/images/favicon/favicon-de559576ac76bfe6dcacd4148764f1b8.ico";